import { TranscodePreset } from "../../features/api/apiSlice";
import { Props } from "../Popup";

export enum ViewModes {
  "PRESETS_LIST" = "presetsList",
  "CREATE_PRESET" = "createPreset",
  "EDIT_PRESET" = "editPreset"
};

interface TranscodePresetsPopupProps extends Props {
  selectedTranscodePreset?: TranscodePreset;
  handleSelectPreset?: (transcodePreset: TranscodePreset | undefined) => void;
};

export default TranscodePresetsPopupProps;